const features = [
  {
    icon: 'ri-radar-line',
    title: '全网覆盖',
    desc: '覆盖微博、抖音、小红书、知乎、豆瓣等主流平台，以及 Telegram、Discord 等私域渠道，确保不遗漏任何一条重要爆料线索。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '实时更新',
    desc: '7×24 小时不间断监控全网热点，重大爆料事件发生后 15 分钟内完成核实与发布，确保你始终走在吃瓜第一线。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '深度挖掘',
    desc: '独家调查团队对每一条重大爆料进行多维度交叉验证与深度追踪报道，还原事件全貌，提供独家视角解读。',
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: '匿名投稿',
    desc: '采用端到端加密技术保护投稿人隐私，绝不透露信息来源。所有爆料均经匿名化处理后发布，让知情人无后顾之忧。',
  },
  {
    icon: 'ri-filter-line',
    title: '精准检索',
    desc: '自研黑料搜索引擎支持按人名、事件、时间、热度等多维度精准检索，海量爆料档案一键定位，吃瓜效率翻倍。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            为什么数百万吃瓜群众选择暗网吃瓜？五大核心能力为你揭秘
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {features.map((item, i) => (
            <div
              key={i}
              className="group bg-background-200/80 border border-background-300/30 rounded-xl p-6 text-center hover:border-primary-500/20 transition-all"
            >
              <div className="w-12 h-12 mx-auto flex items-center justify-center bg-primary-500/10 rounded-xl mb-4 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-xl text-primary-400`}></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-800 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}